/**
 * @module High Speed Internet FAQs
 * @description
 */
import { useContext } from "react";
import { FuelContext } from "@/providers/fuel-provider";
import Link from "next/link";
import FAQs from "@/blocks/FAQS";
import { trackEvent } from "@/js/helpers/tracking";

/**
 * @function Component
 * @description Hero that displays headline and predictive service check
 */
const Component = () => {
  const { clickThrough } = useContext(FuelContext);

  /**
   * @function handleClick
   * @description
   */
  const handleClick = (event) => {
    const { target } = event;
    const text = target.innerHTML;
    const data = {
      elementType: "LINK",
      position: "FAQ",
      text,
      actionOutcome: "INTERNALLINK",
    };

    trackEvent({ action: "elementClicked", data, event });
  };

  return (
    <FAQs
      accordionData={[
        {
          title: "What Frontier services are available in my neighborhood?",
          content: (
            <>
              Frontier Internet services vary by location.{" "}
              <Link key="link-1" href={clickThrough} onClick={handleClick}>
                Check availability
              </Link>{" "}
              to see which plans are available at your address.
            </>
          ),
          contentRaw:
            "Frontier Internet services vary by location. Check availability to see which plans are available at your address.",
        },
        {
          title: "Do I have to sign a contract with Frontier?",
          content: (
            <>
              Select plans and Visa<sup>&reg;</sup> Reward Card offers require a
              12-month commitment. If you cancel early, a prorated early
              termination fee applies.
            </>
          ),
          contentRaw:
            "Select plans and Visa® Reward Card offers require a 12-month commitment. If you cancel early, a prorated early termination fee applies.",
        },
        {
          title: "What Frontier services are available to my home?",
          content: (
            <>
              Frontier Internet services vary depending on your location.{" "}
              <Link key="link-2" href={clickThrough} onClick={handleClick}>
                Check availability
              </Link>{" "}
              to see which plans are available to your home.
            </>
          ),
          contentRaw:
            "Frontier Internet services vary depending on your location. Check availability to see which plans are available to your home.",
        },
        {
          title: "Are there any limits to the amount of data I can use?",
          content:
            "No. You can use the internet as much as you want every month with no extra fees.",
        },
      ]}
    />
  );
};

export default Component;
